import { apiUrl } from './domains';

export interface MerchantApiKeysExportSource {
    _id: string;
    username: string;
    integration_profile?: 'current' | 'typical_v2_2';
    api_key?: string | null;
    webhook_secret?: string | null;
    sandbox_api_key?: string | null;
    sandbox_webhook_secret?: string | null;
}

export function merchantApiKeysFile(merchant: MerchantApiKeysExportSource) {
    const value = (key?: string | null) => key || 'Не задан';
    // Explicit fields only: never serialize the full merchant record.
    const text = [
        `Мерчант: ${merchant.username}`,
        `Документация: ${apiUrl()}/${merchant.integration_profile === 'typical_v2_2' ? 'merchant-docs-v2' : 'merchant-docs'}`,
        '',
        'LIVE — рабочая среда',
        `API key: ${value(merchant.api_key)}`,
        `Webhook / signing secret: ${value(merchant.webhook_secret)}`,
        '',
        'SANDBOX — тестовая среда',
        `API key: ${value(merchant.sandbox_api_key)}`,
        `Webhook / signing secret: ${value(merchant.sandbox_webhook_secret)}`,
        '',
    ].join('\n');
    const id = merchant._id.replace(/[^a-zA-Z0-9_-]/g, '_');
    return { filename: `merchant-api-keys-${id}.txt`, text };
}

export function downloadMerchantApiKeys(merchant: MerchantApiKeysExportSource) {
    const { filename, text } = merchantApiKeysFile(merchant);
    const url = URL.createObjectURL(new Blob(['\uFEFF', text], { type: 'text/plain;charset=utf-8' }));
    const link = document.createElement('a');
    try {
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
    } finally {
        link.remove();
        window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
}
